import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  styled,
  TableCell,
  tableCellClasses,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import { selectors } from '../../reducer';

import * as Styled from './MedicinesListBlock.styles';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    padding: '0px 10px',
    fontWeight: 700,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    padding: '5px 0',
  },
}));

interface MedicinesListProps {
  medicinesOpen: boolean;
}

const MedicinesListBlock: React.FC<MedicinesListProps> = ({
  medicinesOpen,
}) => {
  const { t } = useTranslation();

  const recipeInfo = useSelector(selectors.recipeInfo);

  const medicationsList = useSelector(selectors.medicationsList);
  const medicationsListLoading = useSelector(selectors.medicationsListLoading);
  const medicationsListError = useSelector(selectors.medicationsListError);

  if (!medicinesOpen) return null;

  return (
    <Styled.RecipeInfoBlock>
      <div className="medicines-list-block">
        {/* Предварительная таблица, позже будут данные с ручки */}

        {!medicationsList && medicationsListLoading && (
          <CircularProgress
            size={40}
            color="inherit"
            sx={{ margin: '5px 10px' }}
          />
        )}
        {medicationsListError && (
          <div className="products-err">{t('RXGatePage.PRODUCTS_ERROR')}</div>
        )}

        {recipeInfo &&
          medicationsList &&
          (medicationsList.length > 0 ? (
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 550, tableLayout: 'fixed' }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="10%" align="center">
                      {t('RXGatePage.RecipeInfo.MNN')}
                    </StyledTableCell>
                    <StyledTableCell width="10%" align="center">
                      {t('RXGatePage.PRODUCT_NAME')}
                    </StyledTableCell>
                    <StyledTableCell width="10%" align="center">
                      {t('RXGatePage.MANUFACTURER')}
                    </StyledTableCell>
                    <StyledTableCell width="10%" align="center">
                      {t('RXGatePage.RecipeInfo.DOSAGECONCENTRATION')}
                    </StyledTableCell>
                    <StyledTableCell width="10%" align="center">
                      {t('RXGatePage.DOSAGE_FORM')}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {medicationsList.map((row) => (
                    <TableRow key={row.name}>
                      <StyledTableCell
                        width="60px"
                        align="center"
                        padding="none"
                      >
                        {recipeInfo?.mnn?.name}
                      </StyledTableCell>
                      <StyledTableCell
                        width="60px"
                        align="center"
                        padding="none"
                      >
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell
                        width="60px"
                        align="center"
                        padding="none"
                      >
                        {row.manufacturer || '-'}
                      </StyledTableCell>
                      <StyledTableCell
                        width="60px"
                        align="center"
                        padding="none"
                      >
                        {row.dosage || '-'}
                      </StyledTableCell>

                      <StyledTableCell
                        width="60px"
                        align="center"
                        padding="none"
                      >
                        {row.dosageForm || row.releaseForm || '-'}
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div className="products-empty">
              {t('RXGatePage.PRODUCTS_EMPTY')}
            </div>
          ))}
      </div>
    </Styled.RecipeInfoBlock>
  );
};

export default MedicinesListBlock;
